export default __webpack_public_path__ + "static/media/imageUpload.803ca001.png";